import fetch from './fetch'

class AuditApi {
	// 保存编辑
	public saveAudit(form: any) {
		return fetch({
			url: '/injury/task/pc/save',
			method: 'post',
			data: form,
		})
	}
	// 获取诊断库
	public getClinicalDiagnosis(params: any) {
		return fetch({
			url: '/injury/resource/clinicalDiagnosis',
			method: 'GET',
			params: params,
		})
	}
	// 获取后续治疗库
	public getOperation(params: any) {
		return fetch({
			url: '/injury/resource/operation',
			method: 'GET',
			params: params,
		})
	}
	// 获取重疾种类
	public getDiseaseType(params: any) {
		return fetch({
			url: '/injury/resource/diseaseType',
			method: 'GET',
			params: params,
		})
	}
	// 获取确诊依据
	public getDiagnosisBasis(params: any) {
		return fetch({
			url: '/injury/resource/diagnosisBasis',
			method: 'GET',
			params: params,
		})
	}
	// 获取所属行业
	getIndustryList(params: any) {
		return fetch({
			url: '/injury/resource/industry',
			method: 'GET',
			params: params,
		})
	}
	// 获取一级职业类别
	getFirstVocation(params: any) {
		return fetch({
			url: '/injury/resource/firstVocation',
			method: 'GET',
			params: params,
		})
	}
	// 获取二级职业类别
	getSecondVocation(params: any) {
		return fetch({
			url: '/injury/resource/secondVocation',
			method: 'GET',
			params: params,
		})
	}
}

export default new AuditApi()
